import React, { useRef, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../../Actions/transactions';
import columnClasses from '../columns.css';
import classes from './accountCode.css';
import Select from 'react-select';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import { OptionAccount, OptionAccountR1 } from '../../../UI/select';
import { customStylesAcc, groupStyles, groupBadgeStyles } from '../../../UI/select-styles';
import { isMatchable, groupOption } from '../columnsHelpers';
import DataTableInput from '../../../Input/input';
import { menuPlacement, menuPlacementR1 } from '../selectHelper';

const propsAreEqual = (prev, next) => {
    return prev.focus === next.focus
        && prev.active === next.active
        && prev.row === next.row
        && prev.displayAccount === next.displayAccount;
}

const AccountCode = ({ coords, width, row, matches, transactionCodes, displayAccount, isR1, isRah, handleAcceptRule, handleRemoveRule, disabled, isRuleFound, focus, active, elementFocused, isCreditCardMoneyIn, removeMatchList, removeMatchButton, handleSelectAccount }) => {
    const accountInput = useRef(null);
    const accountCell = useRef(null);
    const acceptRuleChk = useRef(null);
    const [mouseActive, setMouseActive] = useState(false);
    const isMatchButton = !removeMatchList.includes(row.BankDataGUID);
    const chartOfAccounts = isCreditCardMoneyIn ? transactionCodes.chart.filter(item => item.value !== 'match') : transactionCodes.chart;
    const groupOptions = groupOption(row, matches, chartOfAccounts);
    const matchOptions = groupOptions[0].options;
    const codedOption = groupOptions[1].options.find(item => (item.value === row.AccountCode));
    const matchedOption = groupOptions[0].options.find(item => row.MatchId && item.value === row.MatchId);
    const isMatch = isMatchable(row, matches) && isMatchButton;
    const suggestedMatch = (isMatchButton && matchOptions.find(option => row.SuggestedMatches.some(match => match === option.value)));
    const ruleOption = !codedOption && isRuleFound(row) && row.matchedRule 
        && row.matchedRule.allocationRulesDetails && row.matchedRule.allocationRulesDetails.length > 0
        && (() => {
            const ruleAccount = row.matchedRule.allocationRulesDetails[0].account;
            return ruleAccount && groupOptions[1].options.find(item => item.value === ruleAccount.accountCode || item.value === ruleAccount.id);
        })();
    const value = codedOption || matchedOption || suggestedMatch || ruleOption || '';
    const selectedTooltip = value && value.isMatch ? <div style={{ fontSize: 13, lineHeight: 1.6, width: 280 }}>{value.toolTip}</div> : '';

    useEffect(() => {
        if (!disabled) {
            if (!active)
                setMouseActive(false);
            if (accountCell.current)
                Array.from(accountCell.current.getElementsByTagName('input')).forEach((childElem) => childElem.blur());
            if (accountInput.current) {
                if (active && !isMatch && !isRuleFound(row)) {
                    accountInput.current.focus();
                } else if (isRuleFound(row) && acceptRuleChk.current) {
                    acceptRuleChk.current.focus();
                }
            }
        }
    }, [active, accountInput, accountCell]);

    const formatOptionLabel = option => {
        if (option.value === '-1') {
            return 'Coded by Match';
        }
        if (!displayAccount || option.value.length > 10 || option.isMatch || option.isActive === false) {
            return option.label;
        }
        return option.value;
    }

    const formatGroupLabel = data => (
        isRah && <div style={groupStyles}>
            <span>{data.label}</span>
            <span style={groupBadgeStyles}>{data.options.length}</span>
        </div>
    );

    const handleAcceptMatch = row => {
        const match = matches && matches.find(m => m.MatchId === value.value);
        handleSelectAccount(value, row, true, match);
    }

    const handleRemoveMatch = row => {
        removeMatchButton(row.BankDataGUID)
    }

    const selectTemplateClicked = (elem) => {
        setMouseActive(true);
        elementFocused();
    }

    const accountSelectKeyDown = e => {
        if (e.key === 'Backspace' || e.key === 'Delete') {
            handleSelectAccount(null, row, false);
        }
    }

    return <div ref={accountCell} style={{ marginRight: 5, marginBottom: 5, maxWidth: '100%' }}>
        <div className={columnClasses.flexRow} style={{ position: 'relative' }}>
            <Tooltip PopperProps={{ disablePortal: true }} title={selectedTooltip} placement="top">
                <div style={{ flex: 1, minWidth: 0 }}>
                    {(active !== true || disabled) ?
                        <DataTableInput
                            inputElementType="text"
                            value={value ? `${formatOptionLabel(value)}` : `Select...`}
                            onFocus={elementFocused}
                            onClick={(e) => { if (!disabled) selectTemplateClicked(e.target) }}
                            // elementRef={accountInputTemplate}
                            onBlur={() => setMouseActive(false)}
                            disabled={disabled}
                            loading={mouseActive}
                        />
                        : <Select
                            name={`${row.BankDataGUID}_acc`}
                            ref={accountInput}
                            onChange={e => handleSelectAccount(e, row, false)}
                            blurInputOnSelect
                            closeMenuOnSelect
                            onFocus={elementFocused}
                            components={(isR1 || isRah) ? { Option: OptionAccountR1 } : { Option: OptionAccount }}
                            isOptionDisabled={(option) => option.value === '-1' || option.value === '-2' || option.isActive === false}
                            value={value}
                            options={groupOptions}
                            formatOptionLabel={formatOptionLabel}
                            formatGroupLabel={formatGroupLabel}
                            // onKeyDown={e => onKey(e, 'AccountCode', row, this[`${row.BankDataGUID}_acc`].select, false)}
                            styles={customStylesAcc}
                            maxWidth={width}
                            className={`${columnClasses.inputElement}`}
                            defaultMenuIsOpen={mouseActive}
                            onKeyDown={accountSelectKeyDown}
                            menuPortalTarget={!isR1 ? document.getElementById(`DataTable`) : ''}
                            menuPlacement={isR1 ? menuPlacementR1(coords.x, window.innerHeight * 0.38, 'bottom') : menuPlacement(coords.x, window.innerHeight * 0.38, 'auto')}//0.38 is comming from max Heigth of menu(in this case customStylesAcc.menulist.maxHeight is 38vh)
                        />}
                </div>
            </Tooltip>
            <div className={columnClasses.SpreadsheetGrid__cell} style={{ margin: 'auto', padding: '5px' }}>
                {isMatch &&
                    <div className={classes.matchDiv}>
                        <div onClick={() => handleAcceptMatch(row)}>Match</div>
                        <a className={classes.icons} onClick={() => handleRemoveMatch(row)}>
                            <ClearIcon style={{ color: 'red' }} />
                        </a>
                    </div>}
                {isRuleFound(row) &&
                    <Tooltip 
                        title={
                            <div style={{ fontSize: 13, lineHeight: 1.6 }}>
                                <div style={{ fontWeight: 'bold', marginBottom: 5 }}>
                                    {(row.RuleName || (row.matchedRule && row.matchedRule.ruleName) || 'Rule').substring(0, 30)}
                                </div>
                                <div>Allocated to:</div>
                                {row.matchedRule && row.matchedRule.allocationRulesDetails && row.matchedRule.allocationRulesDetails.map((allocation, index) => (
                                    <div key={index}>
                                        Account Code: {allocation.account && allocation.account.accountCode} - {allocation.amount != null ? `$${allocation.amount}` : `${allocation.percentage}%`}
                                    </div>
                                ))}
                            </div>
                        } 
                        placement="top"
                    >
                        <div className={classes.ruleDiv}>
                            <div onClick={() => handleAcceptRule(row)}>Rule</div>
                            {!isR1 && <a className={classes.icons} onClick={() => handleRemoveRule(row)}>
                                <ClearIcon style={{ color: 'red' }} />
                            </a>}
                        </div>
                    </Tooltip>}
            </div>
        </div>
    </div>
}

React.memo(AccountCode, propsAreEqual);

function mapStateToProps(state) {
    return {
        removeMatchList: state.transactions.removeMatchList,
    };
}

export default connect(mapStateToProps, actions)(AccountCode);


// WEBPACK FOOTER //
// ./src/components/TransactionList/Columns/AccountCode/accountCode.js